module.exports = __webpack_public_path__ + "img/calendar.6060bc51.png";